import {
  SET_EXPLORE_QUESTION_DETAILS,
  SET_SHARED_APPROVED_QUESTIONS,
  SET_SINGLE_SHARED_SURVEY,
  SET_SUPPLIER_ADMIN_STAKEHOLDERS,
  SET_SUPPLIER_ASSIGNED_QUESTIONS_FOR_APPROVAL,
  SET_SUPPLIER_ASSIGNED_QUESTIONS_FOR_CONTRIBUTOR,
  SET_SUPPLIER_ASSIGNED_SURVEYS,
  SET_SUPPLIER_SHARED_SURVEYS,
  SET_SUPPLIER_SINGLE_SURVEY_DETAILS,
  SET_SUPPLIER_SINGLE_TASK_DETAILS,
} from "constants/supplierAdmin/supplierAdminConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";

export function setSupplierSharedSurveys(payload) {
  return {
    type: SET_SUPPLIER_SHARED_SURVEYS,
    payload: payload,
  };
}

export function setSupplierAdminStakeholdersList(payload) {
  return {
    type: SET_SUPPLIER_ADMIN_STAKEHOLDERS,
    payload: payload,
  };
}

export function setSingleSharedSurvey(payload) {
  return {
    type: SET_SINGLE_SHARED_SURVEY,
    payload: payload,
  };
}

export function setExploreQuestionDetails(payload) {
  return {
    type: SET_EXPLORE_QUESTION_DETAILS,
    payload: payload,
  };
}

export function setSharedAprrovedQuestions(payload) {
  return {
    type: SET_SHARED_APPROVED_QUESTIONS,
    payload: payload,
  };
}

//------------ Shared Survey --------------

export function getSupplierSharedSurveys(keyword) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey/get_all_shared_surveys",
      bodyData: { keyword },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierSharedSurveys(data?.result));
      },
    });
  };
}

export function getAllSharedQuestions(details) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/get_all_shared_questions",
      hideLoader: false,
      hideMsg: true,
      bodyData: { ...details },
      callback: (data) => {
        dispatch(setSingleSharedSurvey(data?.result));
      },
    });
  };
}
export function getSupplierAdminStakeholders(supplier_id) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/supplier/get_supplier_users",
      hideLoader: false,
      hideMsg: true,
      bodyData: { supplier_id },
      callback: (data) => {
        dispatch(
          setSupplierAdminStakeholdersList(data?.result?.stakeholder_list)
        );
      },
    });
  };
}

export function assignQuestions(details, version) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/assign_questions",
      hideLoader: false,
      hideMsg: false,
      messageType: "success",
      bodyData: { ...details },
      callback: () => {
        dispatch(
          getAllSharedQuestions({
            survey_id: details?.survey_id,
            frequency_id: details?.frequency_id,
            version,
          })
        );
      },
    });
  };
}

export function exploreQuestion(details) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/get_assigned_users_for_question",
      hideLoader: false,
      hideMsg: false,
      bodyData: { ...details },
      callback: ({ result }) => {
        dispatch(setExploreQuestionDetails(result));
      },
    });
  };
}

export function getAllSharedQuestionsApproved(details) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/get_all_shared_questions_with_approved_answer",
      hideLoader: false,
      hideMsg: true,
      bodyData: { ...details },
      callback: ({ result }) => {
        dispatch(setSharedAprrovedQuestions(result));
      },
    });
  };
}

export function changeSharedQuestionStatus(details, version) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/change_shared_question_status",
      hideLoader: false,
      hideMsg: false,
      messageType: "success",
      bodyData: { ...details },
      callback: () => {
        dispatch(
          getAllSharedQuestionsApproved({
            survey_id: details?.survey_id,
            frequency_id: details?.frequency_id,
            version,
          })
        );
      },
    });
  };
}

export function submitSurvey(details, navigate) {
  return async () => {
    await apiBolerplate({
      url: "/survey/submit_survey",
      hideLoader: false,
      hideMsg: false,
      messageType: "success",
      bodyData: { ...details },
      callback: () => {
        navigate("/survey");
      },
    });
  };
}

//------------ Assigned Survey --------------

export function setSupplierAssignedSurveys(payload) {
  return {
    type: SET_SUPPLIER_ASSIGNED_SURVEYS,
    payload: payload,
  };
}

export function setSupplierAssignedQuestionsForContributor(payload) {
  return {
    type: SET_SUPPLIER_ASSIGNED_QUESTIONS_FOR_CONTRIBUTOR,
    payload: payload,
  };
}

export function setSupplierAssignedQuestionsForApproval(payload) {
  return {
    type: SET_SUPPLIER_ASSIGNED_QUESTIONS_FOR_APPROVAL,
    payload: payload,
  };
}

export function setSupplierSingleTaskDetails(payload) {
  return {
    type: SET_SUPPLIER_SINGLE_TASK_DETAILS,
    payload: payload,
  };
}

export function setSupplierSingleSurveyDetails(payload) {
  return {
    type: SET_SUPPLIER_SINGLE_SURVEY_DETAILS,
    payload: payload,
  };
}

export function getSupplierAssignedSurveys(keyword, page, limit) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey/get_all_assigned_surveys",
      bodyData: { keyword, page, limit },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierAssignedSurveys(data?.result));
      },
    });
  };
}

export function getSupplierAssignedQuestionsForContributor(details) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/get_assigned_questions_for_contribution",
      bodyData: { ...details },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierAssignedQuestionsForContributor(data?.result));
      },
    });
  };
}

export function getSupplierAssignedQuestionsForApproval(details) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/get_assigned_questions_for_approval",
      bodyData: { ...details },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierAssignedQuestionsForApproval(data?.result));
      },
    });
  };
}

export function submitContributorAnswers(
  details,
  getAllSharedQuestionsApproved,
  type,
  files
) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey_questions/submit_answer",
      bodyData: { ...details },
      files: files,
      hideLoader: false,
      hideMsg: false,
      messageType: "success",
      callback: (data) => {
        dispatch(setSupplierAssignedQuestionsForContributor(data?.result));
        dispatch(
          getAllSharedQuestionsApproved({
            survey_id: details?.survey_id,
            frequency_id: details?.frequency_id,
            version: details?.version,
          })
        );
      },
    });
  };
}
